module.exports = __webpack_public_path__ + "static/media/sb.cdf3eb7a.jpg";